import { useNavigate } from "react-router-dom";

import { InactiveModal } from "~/components/kiosk/ui/modals/inactive/inactive-modal";
import { kioskActions } from "~/stores/kiosk-session/actions";

export const KioskInactivePage = () => {
  const navigate = useNavigate();
  return (
    <InactiveModal
      onClose={() => {
        kioskActions.session.reset();
      }}
      onConfirm={() => {
        navigate(-1);
      }}
    />
  );
};
